module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Map of operational areas")])])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/xvii-1.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Map drawn by the author using a Rhodesia land tenure map from 1974 as a reference, which can be accessed at  "), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://www.rhodesia.me.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.rhodesia.me.uk")])]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Key – TTLs operating within Support Unit and Special Forces:")])]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("1.")]), _vm._v(" Mangwende")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("2.")]), _vm._v(" Mudzi")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("3.")]), _vm._v(" Inyanga North")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("4.")]), _vm._v(" Wedza")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("5.")]), _vm._v(" Chiduku")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("6.")]), _vm._v(" Makoni")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("7.")]), _vm._v(" Manyika")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("8.")]), _vm._v(" Mutasa South")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("9.")]), _vm._v(" Gona re Zhou National Park")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("10.")]), _vm._v(" Mutumbara")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("11.")]), _vm._v(" Maranke")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("12.")]), _vm._v(" Matibi II")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("13.")]), _vm._v(" Diti")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("14.")]), _vm._v(" Chibi")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("15.")]), _vm._v(" Mpimbila")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("16.")]), _vm._v(" Gutsa")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("17.")]), _vm._v(" Centenary: Farming employment")]), _vm._v(" "), _c('p', {
    staticClass: "maps"
  }, [_c('span', {
    staticClass: "maps_float"
  }, [_vm._v("18.")]), _vm._v(" Inyati: Uniform police work"), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440adb08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Maps.vue
// module id = 87
// module chunks = 0